import chakraTheme from "@chakra-ui/theme";
import { extendBaseTheme } from "@chakra-ui/react";

const {
  Alert,
  Button,
  Divider,
  Checkbox,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  Heading,
  IconButton,
  Input,
  Select,
  Stack,
  Tabs,
  TabList,
  Tab,
  Table,
  TabPanels,
  TabPanel,
  Text,
  Textarea,
  Tooltip,
  Switch
} = chakraTheme.components;

export const artyTheme = extendBaseTheme({
  components: {
    Alert,
    Button,
    Checkbox,
    Divider,
    FormErrorMessage,
    FormHelperText,
    FormLabel,
    Heading,
    IconButton,
    Input,
    Select,
    Stack,
    Tabs,
    TabList,
    Tab,
    Table,
    TabPanels,
    TabPanel,
    Text,
    Textarea,
    Tooltip,
    Switch
  },
  styles: {
    global: {
      body: {
        bg: "#f3f2f1",
        height: "auto",
      },
    },
  },
  fonts: {
    body: "Segoe UI, Segoe,-apple-system,BlinkMacSystemFont,Roboto,Helvetica Neue,Tahoma,Helvetica,Arial,sans-serif;",
  },
  colors: {
    red: {
      50: "#f69095",
      100: "#f6787c",
      200: "#f35f61",
      300: "#ee4446",
      400: "#E61E28",
      500: "#E61E28",
      600: "#E61E28",
      700: "#E61E28",
      800: "#be151d",
      900: "#aa1118",
    },
  },
});
